import { LocalPurchaseRecoveryStorage } from './LocalPurchaseRecoveryStorage';
import { PurchaseRecoveryService } from './PurchaseRecoveryService';

export const purchaseRecovery = new PurchaseRecoveryService(
  new LocalPurchaseRecoveryStorage(),
);

export { PurchaseRecoveryService } from './PurchaseRecoveryService';
export type {
  PurchaseRecoveryRecord,
  PurchaseRecoveryStorage,
  PurchaseSnapshot,
} from './types';
